import { site, testimonials } from "@/mocks/heigua";
import SectionHeading from "./SectionHeading";

const principles = [
  { icon: "ri-focus-3-line", title: "认事实", text: "以公开可见的信息与时间线为准，不做未经证实的断言。" },
  { icon: "ri-file-list-3-line", title: "重脉络", text: "把零散片段连成完整时间线，让后来的人也能从头看懂。" },
  { icon: "ri-scales-3-line", title: "分立场", text: "事实、编辑判断与情绪分层呈现，不对读者作单方面引导。" },
  { icon: "ri-safe-3-line", title: "做存档", text: "热度退去后仍保留完整档案，把资料留给真正想查的人。" },
];

const counts = [
  { value: "430+", label: "累计归档期数" },
  { value: "8 年", label: "连续收录跨度" },
  { value: "36 套", label: "经典合集" },
  { value: "58 篇", label: "深度回顾" },
];

export default function About() {
  return (
    <section id="about" className="border-t border-background-200 bg-background-100 py-14 md:py-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <SectionHeading
          index="伍"
          eyebrow="About · Voice"
          title="关于本站与档案口径"
          subtitle="黑瓜档案馆是一座把往期旧料归档整理的资料库，主张在热闹过后，仍留一份可以回看、可以核对的完整脉络。"
        />

        {/* 计数条 */}
        <dl className="mt-10 grid grid-cols-2 gap-3 md:grid-cols-4">
          {counts.map((c) => (
            <div
              key={c.label}
              className="rounded-lg border border-background-200 bg-background-50 px-4 py-5 text-center"
            >
              <dd className="font-heading text-3xl font-black text-primary-600">{c.value}</dd>
              <dt className="mt-1 text-xs text-foreground-500">{c.label}</dt>
            </div>
          ))}
        </dl>

        {/* 内容原则 */}
        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {principles.map((p) => (
            <div
              key={p.title}
              className="rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-accent-300"
            >
              <span className="flex h-10 w-10 items-center justify-center rounded-md bg-secondary-100 text-secondary-900">
                <i className={`${p.icon} text-lg`} />
              </span>
              <h3 className="mt-4 font-heading text-base font-bold text-foreground-950">{p.title}</h3>
              <p className="mt-1.5 text-sm leading-relaxed text-foreground-600">{p.text}</p>
            </div>
          ))}
        </div>

        {/* 口碑 */}
        <div className="mt-14">
          <div className="flex items-end justify-between gap-4">
            <h3 className="font-heading text-2xl font-bold text-foreground-950">
              读者说我们
            </h3>
            <p className="hidden text-sm text-foreground-500 sm:block">来自归档读者区的好评摘录</p>
          </div>
          <div className="mt-6 grid grid-cols-1 gap-4 lg:grid-cols-3">
            {testimonials.map((t) => (
              <figure
                key={t.name}
                className="flex flex-col rounded-lg border border-background-200 bg-background-50 p-6"
              >
                <i className="ri-double-quotes-l text-2xl text-accent-500" />
                <blockquote className="mt-3 flex-1 text-sm leading-relaxed text-foreground-700">
                  {t.text}
                </blockquote>
                <figcaption className="mt-5 flex items-center gap-3 border-t border-background-100 pt-4">
                  <span className="flex h-9 w-9 items-center justify-center rounded-full bg-primary-100 text-sm font-bold text-primary-700">
                    {t.name.slice(0, 1)}
                  </span>
                  <div>
                    <p className="text-sm font-semibold text-foreground-900">{t.name}</p>
                    <p className="text-xs text-foreground-400">{t.handle}</p>
                  </div>
                </figcaption>
              </figure>
            ))}
          </div>
        </div>

        {/* 联系 */}
        <div className="mt-10 flex flex-col items-start justify-between gap-4 rounded-lg border border-accent-300 bg-accent-100/60 px-6 py-5 sm:flex-row sm:items-center">
          <div className="flex items-start gap-3">
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-md bg-accent-500 text-primary-950">
              <i className="ri-mail-send-line text-lg" />
            </span>
            <div>
              <p className="font-heading text-base font-bold text-foreground-950">
                有想补充的旧料，或对我们的整理有建议？
              </p>
              <p className="mt-1 text-sm text-foreground-600">
                欢迎来信告诉我们，联系方式：hello@heigua-archive.example
              </p>
            </div>
          </div>
          <a
            href="#library"
            className="inline-flex shrink-0 items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-search-line" />
            先去档案库看看
          </a>
        </div>
      </div>
    </section>
  );
}